import { 
  formatDateForPrint, 
  escapeHtml, 
  formatNumber, 
  createPrintIframe
} from './printUtils';

/**
 * Impression simple d'un métal sélectionné
 */
export const handleSimplePrint = (selectedMetal, progressiveByMetal, tab, metauxList, filters, fmtC) => {
  if (!selectedMetal || !progressiveByMetal.displayGroups[selectedMetal]) return;
  
  const rows = progressiveByMetal.displayGroups[selectedMetal];
  if (!rows.length) return;
  
  const isGold = String(selectedMetal) === '1';
  const selectedMetalObj = metauxList.find(m => String(m.id_metal) === String(selectedMetal)) || {};
  const metalLabel = selectedMetalObj.description || (isGold ? 'Or' : `Métal ${selectedMetal}`);
  
  const sums = rows.reduce((acc, r) => { 
    acc.entree += r.__entreeFinCents; 
    acc.sortie += r.__sortieFinCents; 
    acc.perte += r.__perteFinCents; 
    return acc; 
  }, { entree: 0, sortie: 0, perte: 0, solde: rows.length > 0 ? rows[0].__soldeMetalCents : 0 });

  const headerColsLabel = (tab === 0 ? 'Source' : (tab === 1 ? 'Fournisseur' : 'Client'));
  
  const bodyRowsHtml = rows.map(r => {
    const entreeDisplay = (tab === 0 && r.__source === 'FOUR') ? '' : formatNumber(r.entree_or_fin != null ? r.entree_or_fin : r.entree_fin);
    const soldeClass = r.__soldeMetalCents < 0 ? 'neg' : 'pos';
    const sourceLabel = (tab === 0 ? 
      (r.__source === 'CLAL' ? 'CLAL' : (r.fournisseur_label || r.client_label || r.fournisseur_raison_soc || r.fournisseur_id || r.client_id || r.__source)) : 
      (tab === 1 ? (r.fournisseur_label || r.fournisseur_raison_soc || r.fournisseur_id) : 
      (r.client_label || r.client || r.client_id)));
    
    return `<tr>
      <td class="c">${formatDateForPrint(r.date_mouvement)}</td>
      <td class="l">${escapeHtml(sourceLabel || '')}</td>
      <td class="c">${r.perte || ''}</td>
      <td class="l">${escapeHtml(r.designation || '')}</td>
      <td>${entreeDisplay}</td>
      <td>${formatNumber(r.sortie_or_750)}</td>
      <td>${fmtC(r.__perteFinCents)}</td>
      <td class="${soldeClass}">${fmtC(r.__soldeMetalCents)}</td>
    </tr>`;
  }).join('');

  const html = `<!DOCTYPE html><html><head><meta charset='utf-8'/><title>Impression ${metalLabel}</title>
  <style>
    body{font-family:Arial,Helvetica,sans-serif;margin:24px;color:#222;}
    h1{font-size:18px;margin:0 0 14px;font-weight:600;}
    table{border-collapse:collapse;width:100%;font-size:12px;}
    th,td{border:1px solid #c9d1d9;padding:4px 6px;text-align:right;}
    th{background:#eef1f5;font-weight:600;}
    td.l, th.l{text-align:left;} td.c, th.c{text-align:center;}
    tfoot td{font-weight:600;background:#f8fafc;}
    .neg{color:#c62828;font-weight:600;} .pos{color:#1b7f36;font-weight:600;}
    @media print { body{margin:8mm;} }
  </style></head><body>
  <h1>Mouvements ${escapeHtml(metalLabel)} </h1>
  <table>
    <thead><tr>
      <th class="c" style="width:70px;">Date</th>
      <th class="l" style="width:150px;">${headerColsLabel}</th>
      <th class="c" style="width:60px;">% Perte</th>
      <th class="l">Désignation</th>
      <th style="width:90px;">Entrée ${isGold ? 'Or Fin' : 'Métal'}</th>
      <th style="width:90px;">Sortie Or 750</th>
      <th style="width:90px;">Perte ${isGold ? 'Or Fin' : 'Métal'}</th>
      <th style="width:95px;">Solde ${isGold ? 'Or Fin' : 'Métal'}</th>
    </tr></thead>
    <tbody>${bodyRowsHtml}</tbody>
    <tfoot><tr>
      <td colspan="4" class="r" style="text-align:right;">Sous-total ${escapeHtml(metalLabel)}</td>
      <td>${fmtC(sums.entree)}</td>
      <td>${fmtC(sums.sortie)}</td>
      <td>${fmtC(sums.perte)}</td>
      <td>${fmtC(sums.solde)}</td>
    </tr></tfoot>
  </table>
  <script>window.addEventListener('afterprint',()=>setTimeout(()=>parent.document.body.removeChild(frameElement),50));window.print();</script>
  </body></html>`;

  createPrintIframe(html);
};